import React, { Component } from 'react'
import fire from '../../config/Fire'
import { Redirect } from 'react-router'

class ConfirmEmail extends Component {
  constructor(props) {
    super(props);
    this.confirm = this.confirm.bind(this);
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      email: localStorage.getItem('emailForSignIn'),
      redirect: false,
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  confirm(e) {
    e.preventDefault()

    if (fire.auth().isSignInWithEmailLink(window.location.href)) {
      if (!this.state.email) {
        alert('Please provide your email for confirmation')
      }
      fire.auth().signInWithEmailLink(this.state.email, window.location.href)
        .then((result) => {
          // You can access the new user via result.user
          localStorage.removeItem('emailForSignIn')
          this.setState({ redirect: true })
        })
        .catch((error) => {
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
        })
    }
  }

  render() {
    if (this.state.redirect === true) {
      return <Redirect to='/' />
    }

    return (

      <div>
        <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
          <div className="container">
            <a className="navbar-brand" href="/">Tree Tracker App</a>
          </div>
        </nav>

        <div className="col-md-5 margin-top-container">
          <form>
            <div className="form-group">
              <label >Confirm your email address</label>
              <input value={this.state.email}
                onChange={this.handleChange}
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter email" />
            </div>
            <button type="submit" onClick={this.confirm} className="btn btn-primary">Confirm</button>
          </form>        </div>

        <footer className="py-5 bg-black bottom-footer ">
          <div className="container">
            <p className="m-0 text-center text-white small">Copyright &copy; Tree Tracker App {new Date().getFullYear()}</p>
          </div>
        </footer>

      </div>
    );
  }
}
export default ConfirmEmail




// WEBPACK FOOTER //
// ./src/components/confirm-email/ConfirmEmail.js